export const getSyntaxOptions = (intl) => [
  {
    label: 'AND',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.andDescription',
      defaultMessage: 'Require both search terms',
      description: 'Description for AND operator',
    }),
    examples: [
      {
        text: 'california AND privacy',
        description: intl.formatMessage(
          {
            id: 'EcBooleanTextSearchPopup.andExample',
            defaultMessage:
              'Return documents that contain the words "california" {operator} "privacy".',
            description: 'Example description for AND operator',
          },
          {
            operator: 'AND',
          },
        ),
      },
    ],
  },
  {
    label: 'OR',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.orDescription',
      defaultMessage: 'Require either search term',
      description: 'Description for OR operator',
    }),
    examples: [
      {
        text: 'publicity OR trademark',
        description: intl.formatMessage(
          {
            id: 'EcBooleanTextSearchPopup.orExample',
            defaultMessage:
              'Return documents that contain the words "publicity" {operator} "trademark".',
            description: 'Example description for OR operator',
          },
          {
            operator: 'OR',
          },
        ),
      },
    ],
  },
  {
    label: 'NOT',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.notDescription',
      defaultMessage: 'Contains one and not another',
      description: 'Description for NOT operator',
    }),
    examples: [
      {
        text: 'termination NOT convenience',
        description: intl.formatMessage(
          {
            id: 'EcBooleanTextSearchPopup.notExample',
            defaultMessage:
              'Return documents that contain the word "termination" and do not contain the word "convenience".',
            description: 'Example description for {operator} operator',
          },
          {
            operator: 'NOT',
          },
        ),
      },
    ],
  },
  {
    label: 'OR NOT',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.orNotDescription',
      defaultMessage: 'Contains one or not another',
      description: 'Description for OR NOT operator',
    }),
    examples: [
      {
        text: 'termination OR NOT convenience',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.orNotExample',
          defaultMessage:
            'Return documents that contain the word "termination" or do not contain the word "convenience".',
          description: 'Example description for OR NOT operator',
        }),
      },
    ],
  },
  {
    label: '/n',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.proximityDescription',
      defaultMessage: 'Within "n" number of words',
      description: 'Description for proximity operator',
    }),
    examples: [
      {
        text: 'data /5 breach',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.proximityExample',
          defaultMessage:
            'Return documents that contain the word "data" within 5 words of the word "breach".',
          description: 'Example description for proximity operator',
        }),
      },
    ],
  },
  {
    label: '-n',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.beforeDescription',
      defaultMessage: 'Within "n" words before',
      description: 'Description for before operator',
    }),
    examples: [
      {
        text: 'indemnify -5 supplier',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.beforeExample',
          defaultMessage:
            'Return documents where the word "supplier" appears within the 5 words preceding the word "indemnify".',
          description: 'Example description for before operator',
        }),
      },
    ],
  },
  {
    label: '+n',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.afterDescription',
      defaultMessage: 'Within "n" words after',
      description: 'Description for after operator',
    }),
    examples: [
      {
        text: 'supplier +5 indemnify',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.afterExample',
          defaultMessage:
            'Return documents where the word "indemnify" appears within the 5 words following the word "supplier".',
          description: 'Example description for after operator',
        }),
      },
    ],
  },
  {
    label: '" "',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.exactPhraseDescription',
      defaultMessage: 'Exact phrase',
      description: 'Description for exact phrase operator',
    }),
    examples: [
      {
        text: '"New York"',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.exactPhraseExample',
          defaultMessage:
            'Return documents that contain the exact phrase "New York".',
          description: 'Example description for exact phrase operator',
        }),
      },
    ],
  },
  {
    label: '()',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.orderOfOperationsDescription',
      defaultMessage: 'Order of operations',
      description: 'Description for order of operations operator',
    }),
    examples: [
      {
        text: '2020 AND (extend OR renew)',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.orderOfOperationsExample',
          defaultMessage:
            'Return documents that contain the word "2020," plus either the word "extend" or the word "renew".',
          description: 'Example description for order of operations operator',
        }),
      },
    ],
  },
  {
    label: '✱',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.wildcardDescription',
      defaultMessage: 'Treat word as stem',
      description: 'Description for wildcard operator',
    }),
    examples: [
      {
        text: 'service*',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.wildcardExample1',
          defaultMessage:
            'Return documents that contain: "service", "services", "serviced", "servicing".',
          description: 'First example description for wildcard operator',
        }),
      },
      {
        text: '*post',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.wildcardExample2',
          defaultMessage:
            'Return documents that contain: "post", "repost", "lamppost".',
          description: 'Second example description for wildcard operator',
        }),
      },
      {
        text: '*post*',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.wildcardExample3',
          defaultMessage:
            'Return documents that contain: "post", "lamppost", "repost", "poster", "posted", "posting".',
          description: 'Third example description for wildcard operator',
        }),
      },
    ],
  },
  {
    label: 'fuzzy ()',
    description: intl.formatMessage({
      id: 'EcBooleanTextSearchPopup.fuzzyDescription',
      defaultMessage: 'Fuzzy match',
      description: 'Description for fuzzy match operator',
    }),
    examples: [
      {
        text: 'fuzzy (confidential)',
        description: intl.formatMessage({
          id: 'EcBooleanTextSearchPopup.fuzzyExample',
          defaultMessage:
            'Return documents that contain "confidntia", "confidentil", "onfidential", etc. Can place one word or an entire phrase or sentence in parentheses.',
          description: 'Example description for fuzzy match operator',
        }),
      },
    ],
  },
];
